
const SESSION_KEY = 'SESSION'
const SESSION_EXPIRES = 60 * 60 * 1000

export function setSessionStorage(data) {
  const expires = Date.now() + SESSION_EXPIRES
  sessionStorage.setItem(SESSION_KEY, JSON.stringify({ ...data, expires }))
}

export function getSessionStorage() {
  let session = null
  try {
    const sessionData = sessionStorage.getItem(SESSION_KEY)
    if (sessionData) {
      session = JSON.parse(sessionData)
    }

    // eslint-disable-next-line
  } catch (e) {
  }
  if (session && session.expires > Date.now()) {
    return session
  }
}

export function clearSessionStorage() {
  sessionStorage.removeItem(SESSION_KEY)
}
